import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  CustomsIcon,
  AutomatedCustomTracker,
  CreateShipmentUsingSBBE,
  CustomAnalyticsDashboard,
} from '../../assets';

const CustomsPageUAE = () => {
  const productData = {
    productName: 'Customs',
    tagline: 'UAE Freight Documentation and VAT Compliance',
    metaDescription:
      'UAE customs documentation module for freight forwarders: manage import/export document packages, UAE VAT (0%/5%) compliance, and customs analytics in AED. Mirsal 2 integration on the roadmap.',
    description:
      'Manage UAE customs documentation and VAT compliance in one platform: complete import and export document packages, UAE VAT auto-calculation, customs analytics in AED, and shipment-level status tracking. Mirsal 2 and MPCI integrations are on the active roadmap.',
    icon: CustomsIcon,
    pageUrlOverride: 'https://shipmnts.com/uae/products/customs',
    currency: 'AED',
    features: [
      {
        title: 'UAE VAT Compliance',
        description:
          'UAE VAT is calculated automatically: 0% on international freight transport and 5% on local handling, storage, and ancillary services. VAT flows through to invoicing, receivables, and tax reporting without manual intervention.',
        image: AutomatedCustomTracker,
      },
      {
        title: 'Customs Document Management',
        description:
          'Manage complete UAE import and export document packages: commercial invoices, packing lists, bills of lading, airway bills, certificates of origin, and customs declarations: organised per shipment in a single workspace.',
        image: CreateShipmentUsingSBBE,
      },
      {
        title: 'Customs Analytics Dashboard',
        description:
          'Track clearance status, document completeness, and duty estimates across your UAE import and export portfolio: with branch-wise reporting in AED.',
        image: CustomAnalyticsDashboard,
      },
    ],
    faqs: [
      {
        question: 'How does Shipmnts handle UAE VAT for freight forwarding?',
        answer:
          'Shipmnts handles UAE VAT automatically based on shipment type: 0% on international freight transport and 5% on local handling, storage, and ancillary services. VAT is calculated at invoice level and flows through to receivables, payables, and tax reporting.',
      },
      {
        question: 'Does Shipmnts support Mirsal 2 for UAE customs declarations?',
        answer:
          'Mirsal 2 integration is on the Shipmnts roadmap and is not yet available. UAE freight forwarders currently manage Mirsal 2 declarations through the Federal Customs Authority portal or a licensed customs agent. Shipmnts manages the documentation workflow and VAT compliance today.',
      },
      {
        question: 'Does Shipmnts support the MPCI pre-loading manifest mandate?',
        answer:
          'MPCI (Maritime Pre-Clearance Information) compliance is in active development at Shipmnts. Today, Shipmnts manages the shipment documentation and manifest data preparation workflow. Direct MPCI submission is on the near-term roadmap.',
      },
      {
        question: 'What UAE customs documentation does Shipmnts manage today?',
        answer:
          'Shipmnts manages complete UAE import and export document packages: commercial invoices, packing lists, bills of lading, airway bills, certificates of origin, and packing declarations: all organised per shipment and shareable directly with customers via Activity 360.',
      },
      {
        question: 'Is Shipmnts suitable for UAE freight forwarders operating across multiple emirates?',
        answer:
          'Yes. Shipmnts supports multi-branch UAE operations natively: branch-wise P&L in AED, configurable approval workflows per branch, and per-shipment profitability tracking across Dubai, Abu Dhabi, Sharjah, and other UAE locations.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default CustomsPageUAE;
